/**
 * WhatsApp Helper Utilities
 * Cleans phone numbers, formats for WhatsApp API/Web, and opens WhatsApp chat.
 */

export function cleanWhatsAppNumber(phone: string | undefined | null): string {
  if (!phone) return "";
  // Strip everything except digits
  let cleaned = String(phone).replace(/\D/g, "");

  // If number starts with 0 (e.g. 09876543210), strip leading 0
  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }

  // If 10 digits (standard Indian 10-digit mobile number 6xxx-9xxx), prefix 91
  if (cleaned.length === 10) {
    cleaned = "91" + cleaned;
  }

  return cleaned;
}

export function getWhatsAppUrl(phone: string | undefined | null, message?: string): string {
  const number = cleanWhatsAppNumber(phone);
  if (!number) return "";
  const encodedText = message ? `&text=${encodeURIComponent(message)}` : "";
  // api.whatsapp.com works across desktop (redirects to WhatsApp Web/App) and mobile (opens WhatsApp app)
  return `https://api.whatsapp.com/send?phone=${number}${encodedText}`;
}

export function openWhatsAppChat(phone: string | undefined | null, message?: string): boolean {
  const url = getWhatsAppUrl(phone, message);
  if (!url) return false;
  try {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) {
      win.focus();
      return true;
    }
    return false;
  } catch {
    return false;
  }
}
